import { ComponentParameter } from "./mlModel-parameters.model";

export class MlModel{
  customComponentId: number;
  businessDescription: string;
  componentType: string;
  componentName: string;
  lastUpdatedDate: Date;
  createdBy: string;
  refinaryName : string;
  apiUrl: string;
  inputParameters: ComponentParameter[];
  outputParameters: ComponentParameter[];
  modelImage;

  constructor() {
    this.customComponentId = 0;
    this.businessDescription = '';
    this.componentType = '';
    this.componentName = '';
    this.lastUpdatedDate = new Date();
    this.createdBy = '';
    this.refinaryName = '';
    this.apiUrl = '';
    this.inputParameters = [];
    this.outputParameters = [];
    this.modelImage = '';
  }
}
